<template>
  <div>
    <template>
      <div class="section-title">Produk</div>
      <a-row class="checkout-cart">
        <a-col
          :span="24"
          class="checkout-cart__content px-2 py-4 mb-1"
        >
          <!-- merah disini adalah eslint -->
          <div
            v-for="(cart, index) in carts"
            :key="index"
          >
            <!-- This is Item Lists on checkout -->
            <a-row :key="`${index}-content`">
              <a-col
                class="mb-2"
              >
                <a-row
                  class="mb-3 item-product-container"
                  v-for="(item, index) in cart.cart_list"
                  :key="index"
                >
                  <a-row class="item-product">
                    <a-col>
                      <img
                        style="width: 68.3px; height: 66.51px;"
                        :src="item.showimg_url || 'https://ik.imagekit.io/powerbiz/no-image.png?ik-sdk-version=javascript-1.4.3&updatedAt=1603265244531'"
                      />
                    </a-col>
                    <a-col :span="12">
                      <div class="product-title">
                        {{ item.catalog_title }}
                      </div>
                      <div class="product-size mt-2">
                        <template v-if="item.price.product_discount_value > 0">
                          <span style="text-decoration: line-through;">{{ item.price.original_price | currency }}</span>
                          <span class="discount-tag">
                            <span v-if="item.price.promotion_type?.toLowerCase() === 'percentage'">
                              <a-tooltip :title="`Diskon maksimal Rp. ${toCurrency(item.price.promotion_max_value || 0)}`">
                                {{ item.price.product_discount_value }}% OFF
                              </a-tooltip>
                            </span>
                            <span v-else>
                              {{ item.price.product_discount_value | currency }} OFF
                            </span>
                          </span>
                          <div class="final-price">{{ item.price.selling_price | currency }}</div>
                        </template>
                        <template v-else>
                          <span>{{ item.price.selling_price | currency }}</span>
                        </template>
                      </div>
                      <div class="product-size">
                        {{ item.quantity }} {{ item.uom }}
                      </div>
                    </a-col>
                    <a-col
                      :span="7"
                      class="product-align"
                    >
                      <div class="product-total">
                        <b>{{ (item.price.selling_price * item.quantity) | currency }}</b>
                      </div>
                    </a-col>
                  </a-row>
                </a-row>
                <a-row
                  class="mb-3 item-product-container"
                  v-if="cart.cart_list.length"
                >
                  <a-row class="item-product">
                    <a-col>
                      <b>SubTotal</b>
                    </a-col>
                    <a-col :span="12">
                    </a-col>
                    <a-col
                      :span="7"
                      class="product-align"
                    >
                      <div class="product-total" style="color: var(--biz-secondary-100)">
                        <b>Rp. {{ toCurrency(totalProduct) }}</b>
                      </div>
                    </a-col>
                  </a-row>
                </a-row>
              </a-col>
            </a-row>
            <!-- End of Item Lists on checkout -->
          </div>
        </a-col>
      </a-row>
    </template>
    <template>
      <div
        class="btn-voucher px-2 py-3 mb-4 mt-4"
        @click="emitShowModalVoucher(true)"
        v-if="!isGuest"
      >
        <a-col class="voucher-container">
          <div class="voucher-title-icon"><Kupon />Gunakan Kupon</div>
          <a-icon
            type="right"
            class="float-right right-button"
          />
        </a-col>
      </div>
      <div class="checkout-calculation px-2 py-2 mb-3" v-if="!isGuest && useCoinsForPayment">
        <div class="px-2 py-2">
          <a-checkbox
            :checked="seen"
            @change="onChangeUsedCoin"
          >
            <span class="title">{{ $t('purchase.checkout.use_point_have') }}</span>
          </a-checkbox>
          <div class="title ml-3 w-50">
            <div class="py-3">
              <div class="d-flex">
                <Koin />
                <div class="ml-3" style="color: var(--biz-tertiary-100)">
                  {{ availablePoint }} Koin
                </div>
              </div>
              <div v-if="seen">
                <select
                  name="list-coin"
                  id="list-coin"
                  class="p-2 mt-4 w-100"
                  v-model="x"
                >
                  <option
                    value=""
                    disabled
                    selected
                  >-- Pilih tipe pembayaran coin --</option>
                  <option value="one">Pakai semua Koin</option>
                  <option value="two">Pakai sebagian Koin</option>
                </select>
                <div v-if="x === 'one'" class="mt-3">
                  <a-input-number
                    disabled
                    type="number"
                    size="large"
                    class="input-coin w-100"
                    v-model="tempUsedPoints"
                  />
                </div>
                <div v-if="x === 'two'" class="mt-3">
                  <template>
                    <form v-on:submit.prevent="onSubmit">
                      <a-input-number
                        v-model="loyaltyPoints"
                        class="input-coin w-100"
                        size="large"
                        type="number"
                        :min="0"
                        @change="handleChangeLoyalty"
                      />
                    </form>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModalVoucher
        :voucherOnFaktur="voucherOnFaktur"
        :showModal="showModalVoucher"
        :voucherUsed="voucherUsed"
        @emitShowModal="emitShowModalVoucher"
        @emitSubmitModal="emitSubmitModalVoucher"
      />
    </template>
    <a-modal
      :visible="showModalPayment"
      title="Pembayaran"
      :maskClosable="false"
      :bodyStyle="{ height: '60vh', overflow: 'auto', }"
      :maskStyle="{ opacity: '0.8', backgroundColor: '#000000' }"
      @ok="() => undefined"
      @cancel="onCloseAndCancelPayment"
    >
      <div>
        <div id="drawer-payment"></div>
        <div class="position: sticky; top: 0;">
          <div class="section-title mt-0">Ringkasan Pembayaran</div>
          <div class="text-remaining-price">Rp. {{ toCurrency(grandTotal + creditLimitUsage) }}</div>
        </div>
        <a-divider />
        <a-row>
          <a-col
            :span="24"
            :class="!isMobileView ? 'payment-method' :'payment-method w-100'"
          >
            <div class="section-title mt-0">Metode Pembayaran</div>
            <a-row class="checkout-cart" v-if="!data_method && !selectedMethod">
              <a @click="handleSelectPayment">
                <a-col
                  :span="24"
                  class="payment-method px-2 py-2"
                >
                  <div class="payment-method__calculation px-2">
                    <div class="title-payment-method">
                      <CreditCardIcon />
                      <div>Pilih Metode Pembayaran</div>
                    </div>
                    <div>
                      <a-icon
                        type="right"
                        class="float-right right-button"
                      />
                    </div>
                  </div>
                </a-col>
              </a>
            </a-row>
            <template v-if="data_method && selectedMethod">
              <a-row class="checkout-cart">
                <a @click="handleSelectPayment">
                  <a-col
                    :span="24"
                    class="payment-method px-2 py-2"
                  >
                    <div class="payment-method__calculation px-2">
                      <div class="title-payment-method">
                        <CreditCardIcon />
                        <div>Ganti Metode Pembayaran</div>
                      </div>
                      <div>
                        <a-icon
                          type="right"
                          class="float-right right-button"
                        />
                      </div>
                    </div>
                  </a-col>
                </a>
              </a-row>
              <div class="card p-4 mb-0">
                <div class="d-flex justify-content-between align-items-cente">
                  <span class="">{{ data_method ? data_method.payment_name : '-' }}</span>
                  <img
                    style="width: 58.3px;"
                    :src="data_method.image"
                  />
                </div>
                <div class="text-remaining-price" v-if="(data_method && data_method.term.toUpperCase() === 'CAD')">
                  Rp. {{ toCurrency(creditLimitUsage) }}
                </div>
                <template v-if="remainingPrice > 0 && selectedStatusCredit === 0 && (data_method && data_method.term.toUpperCase() === 'CAD')">
                  <a-divider class="mt-3 mb-0"/>
                  <div class="d-flex justify-content-between align-items-center mt-3">
                    <div class="text-dark">Sisa Pembayaran</div>
                    <div class="text-remaining-price">Rp. {{ toCurrency(remainingPrice) }}</div>
                  </div>
                  <a-row class="checkout-cart mt-4" >
                    <a @click="handleSelectMixPayment">
                      <a-col
                        :span="24"
                        class="mix-payment-method px-2 py-2"
                      >
                        <div class="mix-payment-method__calculation px-2">
                          <div class="title"> Pilih Metode Sisa Pembayaran </div>
                          <div>
                            <a-icon
                              type="right"
                              class="float-right right-button"
                            />
                          </div>
                        </div>
                      </a-col>
                    </a>
                  </a-row>
                </template>
                <a-radio-group
                  :defultValue="1"
                  name="radioGroup"
                  class="selected-payment-container d-flex justify-content-between align-items-center"
                  v-if="data_mix_method"
                >
                  <div>
                    <img
                      style="width: 58.3px; height: 26.51px;"
                      :src="data_mix_method.image"
                    />
                    <span class="ml-3">{{ data_mix_method ? data_mix_method.payment_name : '-' }}</span>
                  </div>
                  <a-radio class="list-card2" />
                </a-radio-group>
              </div>
            </template>
            <div class="selected-payment mb-3" v-if="voucherUsed && voucherUsed.length > 0">
              <a-radio-group
                :defultValue="1"
                name="radioGroup"
                class="selected-payment-container py-2 pr-5 align-items-center d-flex"
                style="width: fit-content;"
              >
                <svg width="32" height="31" viewBox="0 0 32 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="16.0013" cy="15.1107" r="13.3333" fill="var(--biz-accent-status-1)"/>
                  <circle cx="16.0013" cy="5.33333" r="5.33333" fill="var(--biz-accent-status-1)"/>
                  <circle cx="5.33333" cy="15.1107" r="5.33333" fill="var(--biz-accent-status-1)"/>
                  <circle cx="8.88802" cy="7.99935" r="5.33333" fill="var(--biz-accent-status-1)"/>
                  <circle cx="8.88802" cy="22.222" r="5.33333" fill="var(--biz-accent-status-1)"/>
                  <circle cx="23.1107" cy="7.99935" r="5.33333" fill="var(--biz-accent-status-1)"/>
                  <circle cx="23.1107" cy="22.222" r="5.33333" fill="var(--biz-accent-status-1)"/>
                  <circle cx="26.6654" cy="15.1107" r="5.33333" fill="var(--biz-accent-status-1)"/>
                  <circle cx="16.0013" cy="24.89" r="5.33333" fill="var(--biz-accent-status-1)"/>
                  <path d="M13.732 11.8434C14.5856 10.9897 14.5856 9.60522 13.732 8.75157C12.8783 7.89791 11.4939 7.89791 10.6402 8.75157C9.78659 9.60522 9.78659 10.9897 10.6402 11.8434C11.4942 12.6974 12.8783 12.6974 13.732 11.8434ZM22.4767 17.4965C21.6231 16.6428 20.2386 16.6428 19.385 17.4965C18.5313 18.3501 18.5313 19.7346 19.385 20.5883C20.2386 21.4419 21.6231 21.4419 22.4767 20.5883C23.3307 19.7346 23.3307 18.3505 22.4767 17.4965ZM22.4104 9.59087L21.6378 8.81818C21.2108 8.39118 20.5187 8.39118 20.0921 8.81818L10.7068 18.2036C10.2798 18.6306 10.2798 19.3227 10.7068 19.7493L11.4795 20.522C11.9065 20.949 12.5986 20.949 13.0252 20.522L22.4104 11.1366C22.8374 10.7099 22.8374 10.0179 22.4104 9.59087Z" fill="white"/>
                </svg>
                <div class="ml-2">{{ voucherUsed ? voucherUsed.length : '-' }} Voucher Dipakai</div>
              </a-radio-group>
            </div>
          </a-col>
        </a-row>
        <a-drawer
          v-if="modalVisible"
          :title="$t('purchase.checkout.select_payment_method')"
          placement="bottom"
          :visible="modalVisible"
          :get-container="getContainer('drawer-payment')"
          height="90%"
          headerStyle="position: sticky; top: 0; z-index: 99;"
          style="position: absolute;"
          @close="handleCancel"
        >
          <div class="checkout-cart__pay-method">
            <template>
              <a-collapse
                class="mb-3"
                :bordered="false"
                expand-icon-position="right"
                accordion
                style="background: var(--biz-brand-base);"
              >
                <a-collapse-panel
                  v-for="({ payment_type, payment_method }, key) in (data.payment_method || [])"
                  :key="key"
                  v-model="activeKey"
                  class="text-dark"
                  :header="typePaymentMap[payment_type]"
                >
                  <a-radio-group
                    v-model="selectedMethod"
                    class="w-100"
                  >
                    <div
                      v-for="({ image, payment_name, id, method }, i) in payment_method"
                      :key="i"
                      style="cursor: pointer;"
                    >
                      <div @click="onChangePaymentMethod(id, payment_type, method)" class="text-secondary d-flex flex-row align-items-center justify-content-between">
                        <div>
                          <a-radio
                            class="list-card"
                            :value="id"
                            :disabled="(payment_type.toUpperCase() === 'CAD' && invalidStatusCredit === true) || (payment_type.toUpperCase() === 'VA' && isMaxVAAmount(method))"
                            style="background: var(--biz-brand-base);"
                          />
                          <span style="color: var(--biz-base-100)">{{ payment_name }}</span>
                        </div>
                        <div>
                          <img
                            :src="image"
                            style="width: 73.52px;"
                            :alt="i"
                            class="mr-2"
                          />
                        </div>
                      </div>
                        <a-input
                          v-if="selectedMethod === id && method === 'xendit_ovo_ewallet'"
                          :value="phoneOVO"
                          @change="changePhoneOVO"
                          placeholder="No Handphone OVO"
                          type="number"
                        />
                      <div class="disclaimer-max-payment d-flex w-100 pr-2" v-if="payment_type.toUpperCase() === 'VA' && isMaxVAAmount(method)">
                        <div
                          class="d-flex w-100 p-3 info-container mb-4"
                          :style="{
                            backgroundColor: 'var(--biz-brand-base)',
                            color: 'var(--biz-accent-2)',
                            border: '1px solid var(--biz-accent-2)'
                          }"
                        >
                          <div>
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="nonenone" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M7.57739 0.0209637C5.07014 0.266687 2.79202 1.62963 1.38128 3.73957C0.870664 4.50295 0.392781 5.61362 0.19639 6.49166C0.0360049 7.20918 0 7.55319 0 8.37554C0 9.19462 0.0360049 9.53863 0.19639 10.2594C0.435332 11.334 0.988498 12.5168 1.67586 13.4276C3.01459 15.2001 4.94904 16.337 7.21407 16.6875C7.74105 16.7662 8.97831 16.7662 9.50529 16.6842C10.9848 16.4582 12.2548 15.9274 13.4233 15.0559C13.8357 14.748 14.726 13.8568 15.0337 13.444C15.9043 12.2743 16.4346 11.0031 16.6604 9.52225C16.7423 8.99476 16.7423 7.75632 16.6637 7.22883C16.3953 5.49239 15.6687 3.94925 14.5493 2.73047C13.2203 1.28889 11.5412 0.387911 9.61331 0.0864906C9.12888 0.00785828 8.05855 -0.0249043 7.57739 0.0209637ZM9.6755 3.35297C10.281 3.64128 10.5396 4.30309 10.2745 4.8961C10.1763 5.10907 9.90462 5.381 9.68532 5.47929C9.04705 5.77088 8.24512 5.51533 7.94072 4.91904C7.81961 4.67987 7.79997 4.27361 7.90471 4.00167C7.99636 3.75595 8.27785 3.46108 8.53316 3.34314C8.88666 3.1826 9.32199 3.18587 9.6755 3.35297ZM8.40878 6.75049C9.1747 6.91431 9.58385 7.468 9.52166 8.25759C9.48565 8.69989 9.44637 8.87681 9.14524 9.95472C8.75901 11.3177 8.70991 11.5372 8.70664 11.9139C8.70009 12.389 8.80156 12.5135 9.24017 12.5692C9.47583 12.5987 9.78351 12.5627 10.0552 12.4676C10.1534 12.4349 10.2385 12.4054 10.2418 12.4054C10.2745 12.4054 10.0977 12.9755 10.0585 12.9951C9.93735 13.0639 8.94558 13.4178 8.76883 13.4571C8.52007 13.5095 7.91126 13.5095 7.65595 13.4538C7.35482 13.3916 7.11915 13.2638 6.89985 13.0443C6.61508 12.7625 6.54634 12.5725 6.54634 12.0778C6.54962 11.6093 6.5889 11.4061 6.93913 10.1677C7.29917 8.88664 7.35482 8.65075 7.35809 8.29363C7.36136 7.9529 7.30572 7.81857 7.11588 7.7039C7.01768 7.6482 6.94894 7.63837 6.65763 7.64165C6.37287 7.64165 6.2714 7.65803 6.07501 7.73011L5.83934 7.81529L5.85571 7.74321C5.86552 7.7039 5.89826 7.56957 5.93099 7.44507L5.98663 7.22228L6.16666 7.1502C6.52671 7.00277 7.15843 6.79636 7.37118 6.75377C7.65595 6.69807 8.16002 6.6948 8.40878 6.75049Z"
                              :fill="'var(--biz-accent-2)'"
                            />
                            </svg>
                          </div>
                          <div class="info-text">Maksimum jumlah transaksi yang dapat di proses untuk {{ payment_name || '-' }} adalah <b>Rp {{ valueMaxVAAmount(method) }}</b>, silahkan gunakan metode pembayaran lain untuk melanjutkan proses transaksi.</div>
                        </div>
                      </div>
                    </div>
                    <div v-if="payment_type.toUpperCase() === 'CAD'">
                      <a-divider class="m-0 my-2"/>
                      <div
                        class="d-flex p-3 info-container mb-4"
                        :style="{
                          backgroundColor: listStatusCredit[selectedStatusCredit].backgroundColor,
                          color: listStatusCredit[selectedStatusCredit].textColor,
                        }"
                        v-if="selectedStatusCredit !== null"
                      >
                        <div>
                          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M7.57739 0.0209637C5.07014 0.266687 2.79202 1.62963 1.38128 3.73957C0.870664 4.50295 0.392781 5.61362 0.19639 6.49166C0.0360049 7.20918 0 7.55319 0 8.37554C0 9.19462 0.0360049 9.53863 0.19639 10.2594C0.435332 11.334 0.988498 12.5168 1.67586 13.4276C3.01459 15.2001 4.94904 16.337 7.21407 16.6875C7.74105 16.7662 8.97831 16.7662 9.50529 16.6842C10.9848 16.4582 12.2548 15.9274 13.4233 15.0559C13.8357 14.748 14.726 13.8568 15.0337 13.444C15.9043 12.2743 16.4346 11.0031 16.6604 9.52225C16.7423 8.99476 16.7423 7.75632 16.6637 7.22883C16.3953 5.49239 15.6687 3.94925 14.5493 2.73047C13.2203 1.28889 11.5412 0.387911 9.61331 0.0864906C9.12888 0.00785828 8.05855 -0.0249043 7.57739 0.0209637ZM9.6755 3.35297C10.281 3.64128 10.5396 4.30309 10.2745 4.8961C10.1763 5.10907 9.90462 5.381 9.68532 5.47929C9.04705 5.77088 8.24512 5.51533 7.94072 4.91904C7.81961 4.67987 7.79997 4.27361 7.90471 4.00167C7.99636 3.75595 8.27785 3.46108 8.53316 3.34314C8.88666 3.1826 9.32199 3.18587 9.6755 3.35297ZM8.40878 6.75049C9.1747 6.91431 9.58385 7.468 9.52166 8.25759C9.48565 8.69989 9.44637 8.87681 9.14524 9.95472C8.75901 11.3177 8.70991 11.5372 8.70664 11.9139C8.70009 12.389 8.80156 12.5135 9.24017 12.5692C9.47583 12.5987 9.78351 12.5627 10.0552 12.4676C10.1534 12.4349 10.2385 12.4054 10.2418 12.4054C10.2745 12.4054 10.0977 12.9755 10.0585 12.9951C9.93735 13.0639 8.94558 13.4178 8.76883 13.4571C8.52007 13.5095 7.91126 13.5095 7.65595 13.4538C7.35482 13.3916 7.11915 13.2638 6.89985 13.0443C6.61508 12.7625 6.54634 12.5725 6.54634 12.0778C6.54962 11.6093 6.5889 11.4061 6.93913 10.1677C7.29917 8.88664 7.35482 8.65075 7.35809 8.29363C7.36136 7.9529 7.30572 7.81857 7.11588 7.7039C7.01768 7.6482 6.94894 7.63837 6.65763 7.64165C6.37287 7.64165 6.2714 7.65803 6.07501 7.73011L5.83934 7.81529L5.85571 7.74321C5.86552 7.7039 5.89826 7.56957 5.93099 7.44507L5.98663 7.22228L6.16666 7.1502C6.52671 7.00277 7.15843 6.79636 7.37118 6.75377C7.65595 6.69807 8.16002 6.6948 8.40878 6.75049Z"
                            :fill="listStatusCredit[selectedStatusCredit].textColor"
                          />
                          </svg>
                        </div>
                        <div class="info-text" v-html="listStatusCredit[selectedStatusCredit].textHtml"></div>
                      </div>
                      <div class="d-flex flex-column px-3" style="gap: 10px 0px;">
                        <div class="d-flex justify-content-between">
                          <div class="text-dark">Distributor</div>
                          <div class="text-dark">Distributor B</div>
                        </div>
                        <div class="d-flex justify-content-between">
                          <div class="text-dark">Status</div>
                          <div
                            class="tag-status"
                            :style="{
                              background: getMultipleBondAllowed === 1 ? 'var(--biz-primary-20)' : 'var(--biz-brand-base)',
                              color: getMultipleBondAllowed === 1 ? 'var(--biz-primary-40)' : 'var(--biz-accent-2)',
                              borderColor: getMultipleBondAllowed === 1 ? 'var(--biz-primary-40)' : 'var(--biz-accent-2)',
                            }"
                          >
                            {{ getCreditBonds }}
                          </div>
                        </div>
                        <div class="d-flex justify-content-between" v-if="getMultipleBondAllowed > 1">
                          <div class="text-dark">Terpakai / Maksimal Pemakaian</div>
                          <div class="tag-credit-usage">{{ getCreditUsage }} / {{ getMultipleBondAllowed }}</div>
                        </div>
                        <div class="d-flex justify-content-between">
                          <div class="text-dark">Batas Maksimal Pelunasan</div>
                          <div class="text-dark">{{ getCreditTermLimit }}</div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center">
                          <div class="text-dark">Sisa Credit Limit</div>
                          <div class="text-credit-balance">{{ getCreditBalance }}</div>
                        </div>
                      </div>
                    </div>
                  </a-radio-group>
                </a-collapse-panel>
              </a-collapse>
            </template>
          </div>
          <div class="d-flex checkout-cart__pay-method pb-3" style="gap:20px; position: sticky; bottom: 0; background: white;">
            <button
              :span="24"
              class="cancel-payment mt-4 mb-2 d-flex w-100 align-items-center justify-content-center"
              @click="handleCancel"
            >
              Batal
            </button>
            <button
              :span="24"
              class="confirm-payment mt-4 mb-2 d-flex w-100 align-items-center justify-content-center"
              @click="handleSelectPayment(selectedMethod)"
              :disabled="!selectedMethod"
            >
              Pilih
            </button>
          </div>
        </a-drawer>
        <a-drawer
          v-if="modalVisibleMixPayment"
          title="Pilih Metode Sisa Pembayaran"
          placement="bottom"
          :visible="modalVisibleMixPayment"
          :get-container="getContainer('drawer-payment')"
          height="90%"
          headerStyle="position: sticky; top: 0; z-index: 50;"
          style="position: absolute;"
          @close="handleCancelMixPayment"
        >
          <div class="checkout-cart__pay-method">
            <template>
              <a-collapse
                class="mb-3"
                :bordered="false"
                expand-icon-position="right"
                accordion
                style="background: var(--biz-brand-base);"
              >
                <a-collapse-panel
                  v-for="({ payment_type, payment_method }, key) in (mixPaymentMethod || [])"
                  :key="key"
                  v-model="activeKey2"
                  class="text-dark"
                  :header="typePaymentMap[payment_type]"
                >
                  <a-radio-group
                    v-model="selectedMixMethod"
                    class="w-100"
                  >
                    <div
                      v-for="({ image, payment_name, id, method }, i) in payment_method"
                      :key="i"
                      style="cursor: pointer;"
                    >
                      <div @click="onChangMixPaymentMethod(id, payment_type, method)" class="text-secondary d-flex flex-row align-items-center justify-content-between">
                        <div>
                          <img
                            :src="image"
                            style="width: 73.52px;"
                            :alt="i"
                            class="mr-2"
                          />
                          <span style="color: var(--biz-base-100)">{{ payment_name }}</span>
                        </div>
                        <div>
                          <a-radio
                            class="list-card"
                            :value="id"
                            :disabled="(payment_type.toUpperCase() === 'VA' &&  isMaxVAAmountMixPayment(method))"
                          />
                        </div>
                      </div>
                      <div class="disclaimer-max-payment d-flex w-100 pr-2"  v-if="payment_type.toUpperCase() === 'VA' && isMaxVAAmountMixPayment(method)">
                        <div
                          class="d-flex w-100 p-3 info-container mb-4"
                          :style="{
                            backgroundColor: 'var(--biz-brand-base)',
                            color: 'var(--biz-accent-2)',
                            border: '1px solid var(--biz-accent-2)'
                          }"
                        >
                          <div>
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                              d="M7.57739 0.0209637C5.07014 0.266687 2.79202 1.62963 1.38128 3.73957C0.870664 4.50295 0.392781 5.61362 0.19639 6.49166C0.0360049 7.20918 0 7.55319 0 8.37554C0 9.19462 0.0360049 9.53863 0.19639 10.2594C0.435332 11.334 0.988498 12.5168 1.67586 13.4276C3.01459 15.2001 4.94904 16.337 7.21407 16.6875C7.74105 16.7662 8.97831 16.7662 9.50529 16.6842C10.9848 16.4582 12.2548 15.9274 13.4233 15.0559C13.8357 14.748 14.726 13.8568 15.0337 13.444C15.9043 12.2743 16.4346 11.0031 16.6604 9.52225C16.7423 8.99476 16.7423 7.75632 16.6637 7.22883C16.3953 5.49239 15.6687 3.94925 14.5493 2.73047C13.2203 1.28889 11.5412 0.387911 9.61331 0.0864906C9.12888 0.00785828 8.05855 -0.0249043 7.57739 0.0209637ZM9.6755 3.35297C10.281 3.64128 10.5396 4.30309 10.2745 4.8961C10.1763 5.10907 9.90462 5.381 9.68532 5.47929C9.04705 5.77088 8.24512 5.51533 7.94072 4.91904C7.81961 4.67987 7.79997 4.27361 7.90471 4.00167C7.99636 3.75595 8.27785 3.46108 8.53316 3.34314C8.88666 3.1826 9.32199 3.18587 9.6755 3.35297ZM8.40878 6.75049C9.1747 6.91431 9.58385 7.468 9.52166 8.25759C9.48565 8.69989 9.44637 8.87681 9.14524 9.95472C8.75901 11.3177 8.70991 11.5372 8.70664 11.9139C8.70009 12.389 8.80156 12.5135 9.24017 12.5692C9.47583 12.5987 9.78351 12.5627 10.0552 12.4676C10.1534 12.4349 10.2385 12.4054 10.2418 12.4054C10.2745 12.4054 10.0977 12.9755 10.0585 12.9951C9.93735 13.0639 8.94558 13.4178 8.76883 13.4571C8.52007 13.5095 7.91126 13.5095 7.65595 13.4538C7.35482 13.3916 7.11915 13.2638 6.89985 13.0443C6.61508 12.7625 6.54634 12.5725 6.54634 12.0778C6.54962 11.6093 6.5889 11.4061 6.93913 10.1677C7.29917 8.88664 7.35482 8.65075 7.35809 8.29363C7.36136 7.9529 7.30572 7.81857 7.11588 7.7039C7.01768 7.6482 6.94894 7.63837 6.65763 7.64165C6.37287 7.64165 6.2714 7.65803 6.07501 7.73011L5.83934 7.81529L5.85571 7.74321C5.86552 7.7039 5.89826 7.56957 5.93099 7.44507L5.98663 7.22228L6.16666 7.1502C6.52671 7.00277 7.15843 6.79636 7.37118 6.75377C7.65595 6.69807 8.16002 6.6948 8.40878 6.75049Z"
                              :fill="'var(--biz-accent-2)'"
                            />
                            </svg>
                          </div>
                          <div class="info-text">Maksimum jumlah transaksi yang dapat di proses untuk {{ payment_name }} adalah <b>Rp {{ valueMaxVAAmount(method) }}</b>, silahkan gunakan metode pembayaran lain untuk melanjutkan proses transaksi.</div>
                        </div>
                      </div>
                    </div>
                  </a-radio-group>
                </a-collapse-panel>
              </a-collapse>
            </template>
          </div>

          <div class="d-flex checkout-cart__pay-method pb-3" style="gap:20px; position: sticky; bottom: 0; background: white;">
            <button
              :span="24"
              class="cancel-payment mt-4 mb-2 d-flex w-100 align-items-center justify-content-center"
              @click="handleCancelMixPayment"
            >
              Batal
            </button>
            <button
              :span="24"
              class="confirm-payment mt-4 mb-2 d-flex w-100 align-items-center justify-content-center"
              @click="handleSelectMixPayment(selectedMixMethod)"
              :disabled="!selectedMixMethod"
            >
              Pilih
            </button>
          </div>
        </a-drawer>
      </div>
      <template #footer>
        <div class="d-flex checkout-cart__pay-method" style="gap:20px; position: sticky; bottom: 0; background: white;">
          <button
            :span="24"
            class="confirm-payment d-flex w-100 align-items-center justify-content-center"
            @click="onPayNow"
            :disabled="
              !(data_method && data_method.term.toUpperCase() !== 'CAD')
              && !(remainingPrice > 0 && (data_method && data_method.term.toUpperCase() === 'CAD') && data_mix_method)
              && !(data_method && data_method.term.toUpperCase() === 'CAD' && remainingPrice === 0)
            "
          >
            Bayar
          </button>
        </div>
      </template>
    </a-modal>
    <template>
      <a-row :style="!isMobileView ? '': 'display:flex; flex-direction:column'">
        <a-col
          :span="24"
          :class="!isMobileView ? 'payment-method' :'payment-method w-100'"
          v-if="selectedShippingType !== 'pickup'"
        >
          <div class="section-title">Metode Pengiriman</div>
          <a-row class="checkout-cart">
            <a
              @click="() => {
                isGuest ? handleShowShippingMethodGuest() : handleShowShippingMethod()
              }"
            >
              <a-col
                :span="24"
                class="payment-method px-2 py-2"
              >
                <div class="payment-method__calculation px-2">
                  <div class="title-payment-method">
                    <TruckFlatIcon />
                    <div>Pilih Metode Pengiriman</div>
                  </div>
                  <div>
                    <a-icon
                      type="right"
                      class="float-right right-button"
                    />
                  </div>
                </div>
              </a-col>
            </a>
          </a-row>
          <div v-if="selectedShipping !== null" class="card p-4 mb-3" style="padding-bottom: 27px!important">
            <div class="d-flex" style="justify-content: space-between">
              <div class="d-flex">
                <b>{{ selectedShipping.name }} - {{ selectedShipping.service.name }}</b>
              </div>
              <div style="color: var(--biz-secondary-100)"><b>(Rp. {{ toCurrency(selectedShipping.price) }})</b></div>
            </div>
          </div>
          <div v-if="selectedShipping !== null" class="card p-4 mb-3 pointer" @click="onChangeInsurace">
            <div class="d-flex justify-content-between">
              <div class="d-flex">
                <a-checkbox
                  :checked="isInsurance"
                  :disabled="selectedShipping.compulsory_insurance == 1"
                />
                <div class="title ml-3">
                  <b>Biaya Asuransi</b>
                </div>
              </div>
              <div style="color: var(--biz-secondary-100)">
                <b>(Rp. {{ toCurrency(selectedShipping.insurance_price) }})</b>
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
    </template>
    <a-modal
      v-model="modalShippingVisible"
      title="Pilih Metode Pengiriman"
      :footer="null"
      :closable="true"
      @cancel="handleShippingCancel"
    >
      <template>
        <div></div>
        <a-radio-group
          v-model="selectedShippingMethod"
          class="w-100"
        >
          <div v-if="isLoadingShippingMethod" class="text-center py-5">
            <a-spin/>
          </div>
          <div v-if="!isLoadingShippingMethod && shippingMethods.length === 0" class="text-center py-5">
            {{ $t('purchase.checkout.no_available_courier') }}
          </div>
          <template v-else>
            <div
              v-for="(item, key) in (shippingMethods || [])"
              :key="key"
              @click="() => (selectedShippingMethod = key)"
              style="cursor: pointer"
            >
              <div
                class="d-flex py-2 mb-3"
                style="justify-content: space-between"
                v-if="shippingMethods.length > 1 ? item?.service?.code !== 'SPU' : true"
              >
                <div class="d-flex">
                  <a-radio :value="key"/>
                  <div>
                    <span v-if="item?.service?.code !== 'SPU'">{{ item.name }} - </span>
                    {{ item.service.name }}</div>
                </div>
                <div><b>(Rp. {{ toCurrency(item.price) }})</b></div>
              </div>
            </div>
          </template>
          <div class="d-flex" style="gap: 15px">
            <button
              :span="24"
              class="btn-method-cancel mt-4 mb-2 d-flex w-100 align-items-center justify-content-center"
              @click="handleCancelShippingMethod"
            >
              Batal
            </button>
            <button
              :span="24"
              class="btn-method-submit mt-4 mb-2 d-flex w-100 align-items-center justify-content-center"
              :class="{
                'btn-disabled-save': selectedShippingMethod === null
              }"
              @click="selectedShippingMethod !== null && handleSelectShippingMethod(selectedShippingMethod)"
            >
              Pilih
            </button>
          </div>
        </a-radio-group>
      </template>
    </a-modal>
    <!-- <a-modal
      :bodyStyle="{ height: '400px', overflow: 'auto', }"
      v-model="modalVisible"
      :title="$t('purchase.checkout.select_payment_method')"
      :closable="true"
      @cancel="handleCancel"
    >
      <div class="checkout-cart__pay-method">
        <template>
          <a-collapse
            class="mb-3"
            :bordered="false"
            expand-icon-position="right"
            accordion
            style="background: var(--biz-brand-base);"
          >
            <a-collapse-panel
              v-for="({ payment_type, payment_method }, key) in (data.payment_method || [])"
              :key="key"
              v-model="activeKey"
              class="text-dark"
              :header="typePaymentMap[payment_type]"
            >
              <a-radio-group
                v-model="selectedMethod"
                class="w-100"
              >
                <div
                  v-for="({ image, payment_name, id, method }, i) in payment_method"
                  :key="i"
                  style="cursor: pointer;"
                >
                  <div @click="onChangePaymentMethod(id, payment_type, method)" class="text-secondary d-flex flex-row align-items-center justify-content-between">
                    <div>
                      <a-radio
                        class="list-card"
                        :value="id"
                        :disabled="(payment_type.toUpperCase() === 'CAD' && invalidStatusCredit === true) || (payment_type.toUpperCase() === 'VA' && isMaxVAAmount(method))"
                        style="background: var(--biz-brand-base);"
                      />
                      <span style="color: var(--biz-base-100)">{{ payment_name }}</span>
                    </div>
                    <div>
                      <img
                        :src="image"
                        style="width: 73.52px;"
                        :alt="i"
                        class="mr-2"
                      />
                    </div>
                  </div>
                    <a-input
                      v-if="selectedMethod === id && method === 'xendit_ovo_ewallet'"
                      :value="phoneOVO"
                      @change="changePhoneOVO"
                      placeholder="No Handphone OVO"
                      type="number"
                    />
                  <div class="disclaimer-max-payment d-flex w-100 pr-2" v-if="payment_type.toUpperCase() === 'VA' && isMaxVAAmount(method)">
                    <div
                      class="d-flex w-100 p-3 info-container mb-4"
                      :style="{
                        backgroundColor: 'var(--biz-brand-base)',
                        color: 'var(--biz-accent-2)',
                        border: '1px solid var(--biz-accent-2)'
                      }"
                    >
                      <div>
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="nonenone" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M7.57739 0.0209637C5.07014 0.266687 2.79202 1.62963 1.38128 3.73957C0.870664 4.50295 0.392781 5.61362 0.19639 6.49166C0.0360049 7.20918 0 7.55319 0 8.37554C0 9.19462 0.0360049 9.53863 0.19639 10.2594C0.435332 11.334 0.988498 12.5168 1.67586 13.4276C3.01459 15.2001 4.94904 16.337 7.21407 16.6875C7.74105 16.7662 8.97831 16.7662 9.50529 16.6842C10.9848 16.4582 12.2548 15.9274 13.4233 15.0559C13.8357 14.748 14.726 13.8568 15.0337 13.444C15.9043 12.2743 16.4346 11.0031 16.6604 9.52225C16.7423 8.99476 16.7423 7.75632 16.6637 7.22883C16.3953 5.49239 15.6687 3.94925 14.5493 2.73047C13.2203 1.28889 11.5412 0.387911 9.61331 0.0864906C9.12888 0.00785828 8.05855 -0.0249043 7.57739 0.0209637ZM9.6755 3.35297C10.281 3.64128 10.5396 4.30309 10.2745 4.8961C10.1763 5.10907 9.90462 5.381 9.68532 5.47929C9.04705 5.77088 8.24512 5.51533 7.94072 4.91904C7.81961 4.67987 7.79997 4.27361 7.90471 4.00167C7.99636 3.75595 8.27785 3.46108 8.53316 3.34314C8.88666 3.1826 9.32199 3.18587 9.6755 3.35297ZM8.40878 6.75049C9.1747 6.91431 9.58385 7.468 9.52166 8.25759C9.48565 8.69989 9.44637 8.87681 9.14524 9.95472C8.75901 11.3177 8.70991 11.5372 8.70664 11.9139C8.70009 12.389 8.80156 12.5135 9.24017 12.5692C9.47583 12.5987 9.78351 12.5627 10.0552 12.4676C10.1534 12.4349 10.2385 12.4054 10.2418 12.4054C10.2745 12.4054 10.0977 12.9755 10.0585 12.9951C9.93735 13.0639 8.94558 13.4178 8.76883 13.4571C8.52007 13.5095 7.91126 13.5095 7.65595 13.4538C7.35482 13.3916 7.11915 13.2638 6.89985 13.0443C6.61508 12.7625 6.54634 12.5725 6.54634 12.0778C6.54962 11.6093 6.5889 11.4061 6.93913 10.1677C7.29917 8.88664 7.35482 8.65075 7.35809 8.29363C7.36136 7.9529 7.30572 7.81857 7.11588 7.7039C7.01768 7.6482 6.94894 7.63837 6.65763 7.64165C6.37287 7.64165 6.2714 7.65803 6.07501 7.73011L5.83934 7.81529L5.85571 7.74321C5.86552 7.7039 5.89826 7.56957 5.93099 7.44507L5.98663 7.22228L6.16666 7.1502C6.52671 7.00277 7.15843 6.79636 7.37118 6.75377C7.65595 6.69807 8.16002 6.6948 8.40878 6.75049Z"
                          :fill="'var(--biz-accent-2)'"
                        />
                        </svg>
                      </div>
                      <div class="info-text">Maksimum jumlah transaksi yang dapat di proses untuk {{ payment_name || '-' }} adalah <b>Rp {{ valueMaxVAAmount(method) }}</b>, silahkan gunakan metode pembayaran lain untuk melanjutkan proses transaksi.</div>
                    </div>
                  </div>
                </div>
                <div v-if="payment_type.toUpperCase() === 'CAD'">
                  <a-divider class="m-0 my-2"/>
                  <div
                    class="d-flex p-3 info-container mb-4"
                    :style="{
                      backgroundColor: listStatusCredit[selectedStatusCredit].backgroundColor,
                      color: listStatusCredit[selectedStatusCredit].textColor,
                    }"
                    v-if="selectedStatusCredit !== null"
                  >
                    <div>
                      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7.57739 0.0209637C5.07014 0.266687 2.79202 1.62963 1.38128 3.73957C0.870664 4.50295 0.392781 5.61362 0.19639 6.49166C0.0360049 7.20918 0 7.55319 0 8.37554C0 9.19462 0.0360049 9.53863 0.19639 10.2594C0.435332 11.334 0.988498 12.5168 1.67586 13.4276C3.01459 15.2001 4.94904 16.337 7.21407 16.6875C7.74105 16.7662 8.97831 16.7662 9.50529 16.6842C10.9848 16.4582 12.2548 15.9274 13.4233 15.0559C13.8357 14.748 14.726 13.8568 15.0337 13.444C15.9043 12.2743 16.4346 11.0031 16.6604 9.52225C16.7423 8.99476 16.7423 7.75632 16.6637 7.22883C16.3953 5.49239 15.6687 3.94925 14.5493 2.73047C13.2203 1.28889 11.5412 0.387911 9.61331 0.0864906C9.12888 0.00785828 8.05855 -0.0249043 7.57739 0.0209637ZM9.6755 3.35297C10.281 3.64128 10.5396 4.30309 10.2745 4.8961C10.1763 5.10907 9.90462 5.381 9.68532 5.47929C9.04705 5.77088 8.24512 5.51533 7.94072 4.91904C7.81961 4.67987 7.79997 4.27361 7.90471 4.00167C7.99636 3.75595 8.27785 3.46108 8.53316 3.34314C8.88666 3.1826 9.32199 3.18587 9.6755 3.35297ZM8.40878 6.75049C9.1747 6.91431 9.58385 7.468 9.52166 8.25759C9.48565 8.69989 9.44637 8.87681 9.14524 9.95472C8.75901 11.3177 8.70991 11.5372 8.70664 11.9139C8.70009 12.389 8.80156 12.5135 9.24017 12.5692C9.47583 12.5987 9.78351 12.5627 10.0552 12.4676C10.1534 12.4349 10.2385 12.4054 10.2418 12.4054C10.2745 12.4054 10.0977 12.9755 10.0585 12.9951C9.93735 13.0639 8.94558 13.4178 8.76883 13.4571C8.52007 13.5095 7.91126 13.5095 7.65595 13.4538C7.35482 13.3916 7.11915 13.2638 6.89985 13.0443C6.61508 12.7625 6.54634 12.5725 6.54634 12.0778C6.54962 11.6093 6.5889 11.4061 6.93913 10.1677C7.29917 8.88664 7.35482 8.65075 7.35809 8.29363C7.36136 7.9529 7.30572 7.81857 7.11588 7.7039C7.01768 7.6482 6.94894 7.63837 6.65763 7.64165C6.37287 7.64165 6.2714 7.65803 6.07501 7.73011L5.83934 7.81529L5.85571 7.74321C5.86552 7.7039 5.89826 7.56957 5.93099 7.44507L5.98663 7.22228L6.16666 7.1502C6.52671 7.00277 7.15843 6.79636 7.37118 6.75377C7.65595 6.69807 8.16002 6.6948 8.40878 6.75049Z"
                        :fill="listStatusCredit[selectedStatusCredit].textColor"
                      />
                      </svg>
                    </div>
                    <div class="info-text" v-html="listStatusCredit[selectedStatusCredit].textHtml"></div>
                  </div>
                  <div class="d-flex flex-column px-3" style="gap: 10px 0px;">
                    <div class="d-flex justify-content-between">
                      <div class="text-dark">Distributor</div>
                      <div class="text-dark">Distributor B</div>
                    </div>
                    <div class="d-flex justify-content-between">
                      <div class="text-dark">Status</div>
                      <div
                        class="tag-status"
                        :style="{
                          background: getMultipleBondAllowed === 1 ? 'var(--biz-primary-20)' : 'var(--biz-brand-base)',
                          color: getMultipleBondAllowed === 1 ? 'var(--biz-primary-40)' : 'var(--biz-accent-2)',
                          borderColor: getMultipleBondAllowed === 1 ? 'var(--biz-primary-40)' : 'var(--biz-accent-2)',
                        }"
                      >
                        {{ getCreditBonds }}
                      </div>
                    </div>
                    <div class="d-flex justify-content-between" v-if="getMultipleBondAllowed > 1">
                      <div class="text-dark">Terpakai / Maksimal Pemakaian</div>
                      <div class="tag-credit-usage">{{ getCreditUsage }} / {{ getMultipleBondAllowed }}</div>
                    </div>
                    <div class="d-flex justify-content-between">
                      <div class="text-dark">Batas Maksimal Pelunasan</div>
                      <div class="text-dark">{{ getCreditTermLimit }}</div>
                    </div>
                    <div class="d-flex justify-content-between align-items-center">
                      <div class="text-dark">Sisa Credit Limit</div>
                      <div class="text-credit-balance">{{ getCreditBalance }}</div>
                    </div>
                  </div>
                </div>
              </a-radio-group>
            </a-collapse-panel>
          </a-collapse>
        </template>
      </div>
      <template #footer>
        <div class="d-flex checkout-cart__pay-method" style="gap:20px; position: sticky; bottom: 0; background: white;">
          <button
            :span="24"
            class="cancel-payment mt-4 mb-2 d-flex w-100 align-items-center justify-content-center"
            @click="handleCancel"
          >
            Batal
          </button>
          <button
            :span="24"
            class="confirm-payment mt-4 mb-2 d-flex w-100 align-items-center justify-content-center"
            @click="handleSelectPayment(selectedMethod)"
            :disabled="selectedMethod === 206 && (phoneOVO === null || phoneOVO?.length < 3 || phoneOVO?.length > 16)"
          >
            Pilih
          </button>
        </div>
      </template>
    </a-modal> -->
    <!-- <a-modal
      v-model="modalVisibleMixPayment"
      :title="$t('purchase.checkout.select_payment_method')"
      :footer="null"
      :closable="false"
      @cancel="handleCancelMixPayment"
    >
      <div class="checkout-cart__pay-method">
        <template>
          <div
            v-for="({ payment_type, payment_method }, key) in (mixPaymentMethod || [])"
            :key="key"
            class="text-dark"
          >
            <a-radio-group
              v-model="selectedMixMethod"
              class="w-100"
            >
              <div
                v-for="({ image, payment_name, id, method }, i) in payment_method"
                :key="i"
                style="cursor: pointer;"
              >
                <div @click="selectedMixMethod = id" class="text-secondary d-flex flex-row align-items-center justify-content-between">
                  <div>
                    <img
                      :src="image"
                      style="width: 73.52px;"
                      :alt="i"
                      class="mr-2"
                    />
                    <span style="color: var(--biz-base-100)">{{ payment_name }}</span>
                  </div>
                  <div>
                    <a-radio
                      class="list-card"
                      :value="id"
                      :disabled="(payment_type.toUpperCase() === 'VA' &&  isMaxVAAmountMixPayment(method))"
                    />
                  </div>
                </div>
                <div class="disclaimer-max-payment d-flex w-100 pr-2"  v-if="payment_type.toUpperCase() === 'VA' && isMaxVAAmountMixPayment(method)">
                  <div
                    class="d-flex w-100 p-3 info-container mb-4"
                    :style="{
                      backgroundColor: 'var(--biz-brand-base)',
                      color: 'var(--biz-accent-2)',
                      border: '1px solid var(--biz-accent-2)'
                    }"
                  >
                    <div>
                      <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M7.57739 0.0209637C5.07014 0.266687 2.79202 1.62963 1.38128 3.73957C0.870664 4.50295 0.392781 5.61362 0.19639 6.49166C0.0360049 7.20918 0 7.55319 0 8.37554C0 9.19462 0.0360049 9.53863 0.19639 10.2594C0.435332 11.334 0.988498 12.5168 1.67586 13.4276C3.01459 15.2001 4.94904 16.337 7.21407 16.6875C7.74105 16.7662 8.97831 16.7662 9.50529 16.6842C10.9848 16.4582 12.2548 15.9274 13.4233 15.0559C13.8357 14.748 14.726 13.8568 15.0337 13.444C15.9043 12.2743 16.4346 11.0031 16.6604 9.52225C16.7423 8.99476 16.7423 7.75632 16.6637 7.22883C16.3953 5.49239 15.6687 3.94925 14.5493 2.73047C13.2203 1.28889 11.5412 0.387911 9.61331 0.0864906C9.12888 0.00785828 8.05855 -0.0249043 7.57739 0.0209637ZM9.6755 3.35297C10.281 3.64128 10.5396 4.30309 10.2745 4.8961C10.1763 5.10907 9.90462 5.381 9.68532 5.47929C9.04705 5.77088 8.24512 5.51533 7.94072 4.91904C7.81961 4.67987 7.79997 4.27361 7.90471 4.00167C7.99636 3.75595 8.27785 3.46108 8.53316 3.34314C8.88666 3.1826 9.32199 3.18587 9.6755 3.35297ZM8.40878 6.75049C9.1747 6.91431 9.58385 7.468 9.52166 8.25759C9.48565 8.69989 9.44637 8.87681 9.14524 9.95472C8.75901 11.3177 8.70991 11.5372 8.70664 11.9139C8.70009 12.389 8.80156 12.5135 9.24017 12.5692C9.47583 12.5987 9.78351 12.5627 10.0552 12.4676C10.1534 12.4349 10.2385 12.4054 10.2418 12.4054C10.2745 12.4054 10.0977 12.9755 10.0585 12.9951C9.93735 13.0639 8.94558 13.4178 8.76883 13.4571C8.52007 13.5095 7.91126 13.5095 7.65595 13.4538C7.35482 13.3916 7.11915 13.2638 6.89985 13.0443C6.61508 12.7625 6.54634 12.5725 6.54634 12.0778C6.54962 11.6093 6.5889 11.4061 6.93913 10.1677C7.29917 8.88664 7.35482 8.65075 7.35809 8.29363C7.36136 7.9529 7.30572 7.81857 7.11588 7.7039C7.01768 7.6482 6.94894 7.63837 6.65763 7.64165C6.37287 7.64165 6.2714 7.65803 6.07501 7.73011L5.83934 7.81529L5.85571 7.74321C5.86552 7.7039 5.89826 7.56957 5.93099 7.44507L5.98663 7.22228L6.16666 7.1502C6.52671 7.00277 7.15843 6.79636 7.37118 6.75377C7.65595 6.69807 8.16002 6.6948 8.40878 6.75049Z"
                        :fill="'var(--biz-accent-2)'"
                      />
                      </svg>
                    </div>
                    <div class="info-text">Maksimum jumlah transaksi yang dapat di proses untuk {{ payment_name }} adalah <b>Rp {{ valueMaxVAAmount(method) }}</b>, silahkan gunakan metode pembayaran lain untuk melanjutkan proses transaksi.</div>
                  </div>
                </div>
              </div>
            </a-radio-group>
          </div>
        </template>
        <div class="d-flex" style="gap:20px">
          <button
            :span="24"
            class="cancel-payment mt-4 mb-2 d-flex w-100 align-items-center justify-content-center"
            @click="handleCancelMixPayment"
          >
            Batal
          </button>
          <button
            :span="24"
            class="confirm-payment mt-4 mb-2 d-flex w-100 align-items-center justify-content-center"
            @click="handleSelectMixPayment(selectedMixMethod)"
          >
            Pilih
          </button>
        </div>
      </div>
    </a-modal> -->
    <b-modal hide-footer hide-header centered v-model="showModalMandatoryShippingAddress" body-class="w-[352]" @hidden="showModalMandatoryShippingAddress = false">
      <div class="d-flex flex-column align-items-center text-center">
        <div class="mb-3">
          <Warning :color="'var(--biz-secondary-100)'"/>
        </div>
        <span>{{ $t('purchase.checkout.please_fill_shipping_address') }}</span>
      </div>
      <div class="d-flex justify-content-center mt-5">
        <button
          @click.prevent="showModalMandatoryShippingAddress = false"
          type="button"
          class="button-close-modal-mandatory px-4 rounded-lg"
        >
          OK
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import CreditCardIcon from '@/components/Icons/CreditCard.vue'
import TruckFlatIcon from '@/components/Icons/TruckFlat.vue'
import ModalVoucher from '@/components/Purchase/Checkout/Cart/modalListVoucher.vue'
import Warning from '@/components/Icons/Warning.vue'
import Kupon from '@/components/Icons/Kupon.vue'
import Koin from '@/components/Icons/Coin.vue'
import { mapGetters } from 'vuex'

const infoStatusCredit = [
  {
    backgroundColor: '#FDF3D1',
    textColor: '#624E17',
    textHtml: 'Sisa credit limit Anda <b>kurang dari total tagihan.</b> Tetap gunakan credit limit dengan ada pilihan pembayaran sisa atau gunakan metode pembayaran lain.',
  },
  {
    backgroundColor: '#F4F4F4',
    textColor: '#015CA1',
    textHtml: 'Mohon untuk <b>melunasi tagihan jatuh tempo</b> Anda terlebih dahulu untuk menggunakan credit limit di tagihan ini atau gunakan metode pembayaran lain.',
  },
  {
    backgroundColor: '#F4F4F4',
    textColor: '#FF0000',
    textHtml: 'Terdapat order yang telah <b>melewati batas maksimal waktu pelunasan.</b> Silahkan untuk melunasi terlebih dahulu tagihan tersebut atau gunakan metode pembayaran lain.',
  },
  {
    backgroundColor: '#F4F4F4',
    textColor: '#015CA1',
    textHtml: 'Pemakaian pembayaran tempo Anda telah mencapai batas maksimal, mohon untuk <b>melunasi tagihan jatuh tempo</b> Anda terlebih dahulu untuk menggunakan credit limit di tagihan ini atau gunakan metode pembayaran lain.',
  },
]
const IGNORE_SHIPPING_CODE = ['SPU']

export default {
  props: {
    carts: {
      type: Array,
      default: () => [],
    },
    paymentList: {
      type: [Array, Object],
      default: () => [],
    },
    pointUsed: {
      type: Number,
      default: () => 0,
    },
    grossAmount: {
      type: Number,
      default: () => 0,
    },
    usedPoints: {
      type: Number,
      default: () => 0,
    },
    sellerId: {
      type: String,
      default: () => '',
    },
    grandTotal: {
      type: Number,
      default: () => 0,
    },
    grandTotalBeforeCreditLimit: {
      type: Number,
      default: () => 0,
    },
    depositReturnUsed: {
      type: Number,
      default: () => 0,
    },
    totalProduct: {
      type: Number,
      default: () => 0,
    },
    voucherOnFaktur: {
      type: Array,
      default: () => [],
    },
    distination_id: {
      type: Number,
      default: () => 0,
    },
    selectedShippingType: {
      type: String,
      default: () => 'pickup',
    },
    totalWeight: {
      type: Number,
      default: () => 0,
    },
    selectedShippingAddress: {
      type: Object,
      default: () => null,
    },
    selectedMethod: {
      type: [String, Number],
      default: () => '',
    },
    selectedMixMethod: {
      type: [String, Number],
      default: () => '',
    },
    isInsurance: {
      type: Boolean,
      default: () => false,
    },
    insuranceCost: {
      type: Number,
      default: () => 0,
    },
    isValidToPay: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    CreditCardIcon,
    ModalVoucher,
    TruckFlatIcon,
    Warning,
    Kupon,
    Koin,
  },
  data: function () {
    return {
      form: this.$form.createForm(this),
      payment: 'Term of Payment',
      poNumber: null,
      modalVisible: false,
      modalVisibleMixPayment: false,
      showModalVoucher: false,
      showModalMandatoryShippingAddress: false,
      activeKey: [],
      activeKey2: [],
      cbd_tf_bank: [],
      cbd_va: [],
      cod: [],
      cad: [],
      data_method: '',
      data_mix_method: '',
      remainingPrice: 0,
      seen: false,
      seen_balance: false,
      seen_points: false,
      loyaltyPoints: 0,
      sum: 0,
      rewardAmountsApplied: [0],
      availablePoint: 0,
      size: 'large',
      x: 'one',
      chooseOption: null,
      data: {
        payment_method: [],
      },
      typePaymentMap: {
        COD: 'Melalui Kurir',
        BANK_TRANSFER: 'Transfer Bank (Verifikasi Manual)',
        VA: 'Virtual Account',
        CAD: 'Pembayaran Tempo',
        EWALLET: 'E-Wallet',
      },
      tempUsedPoints: 0,
      listStatusCredit: infoStatusCredit,
      invalidStatusCredit: false,
      selectedStatusCredit: null,
      mixPaymentMethod: [],
      mixPaymentList: [],
      maximumVAAmount: [],
      voucherUsed: [],
      currency: 0,
      modalShippingVisible: false,
      shippingMethods: [],
      selectedShippingMethod: null,
      selectedShipping: null,
      isLoadingShippingMethod: false,
      phoneOVO: this.$store.state.user.user_data.phone,
      contentCoinTerm: false,
      useCoinsForPayment: true,
      showModalPayment: false,
      creditLimitUsage: 0,
    }
  },
  watch: {
    sum: {
      deep: true,
      immediate: true,
    },
    x: {
      deep: true,
      immediate: true,
      handler() {
        if (this.x === 'one') {
          this.$store.commit('loyalty/SET_LOYALTY_STORE', {
            usedPoints: Number(this.availablePoint),
          })
        } else {
          this.$store.commit('loyalty/SET_LOYALTY_STORE', {
            usedPoints: null,
          })
          this.loyaltyPoints = 0
        }
      },
    },
    isValidToPay: {
      deep: true,
      immediate: true,
      handler(value) {
        this.showModalPayment = value
        this.creditLimitUsage = 0
        this.data_method = ''
        this.data_mix_method = ''
      },
    },
    pointUsed(value) {
      if (value) {
        if (value > this.totalPrice) {
          this.$emit('emitLocalUsedPoints', this.totalPrice)
          this.tempUsedPoints = this.totalPrice
        } else {
          this.$emit('emitLocalUsedPoints', value)
          this.tempUsedPoints = value
        }
      } else {
        this.$emit('emitLocalUsedPoints', 0)
        this.tempUsedPoints = 0
      }
    },
    usedPoints(value) {
      this.$emit('emitLocalUsedPoints', value)
      this.tempUsedPoints = value
    },
    selectedShippingType(value) {
      if (value === 'pickup') {
        this.selectedShipping = this.shippingMethods[0]
      } else {
        this.selectedShipping = null
        this.selectedShippingMethod = null
      }
      this.$emit('emitSelectedShippingMethod', null)
    },
    grandTotal: {
      deep: true,
      immediate: true,
      handler(value) {
        this.remainingPrice = value
      },
    },
    selectedShippingAddress(value) {
      this.selectedShipping = null
      this.selectedShippingMethod = null
      // this.$emit('emitSelectedShippingMethod', null)
      if (value) {
        if (this.selectedShippingType === 'pickup') {
          this.$emit('emitSelectedShippingMethod', this.shippingMethods[0])
        } else {
          this.$emit('emitSelectedShippingMethod', null)
        }
      } else {
        this.$emit('emitSelectedShippingMethod', null)
      }
    },
    // totalWeight() {
    //   this.getShippingMethod()
    // },
  },
  computed: {
    // ...mapState(['dashboard']),
    ...mapGetters('user', ['isGuest']),
    isMobileView() {
      return this.$store.state.settings.isMobileView
    },
    options() {
      if (!this.paymentList) {
        return []
      }
      return this.paymentList.map((item) => {
        if (item.payment_method.length) {
          if (item.payment_type === 'BANK_TRANSFER') {
            const temp = item.payment_method
            this.cbd_tf_bank.push(...temp)
          } else if (item.payment_type === 'VA') {
            const temp = item.payment_method
            this.cbd_va.push(...temp)
          } else if (item.payment_type === 'COD') {
            const temp = item.payment_method
            this.cod.push(...temp)
          } else if (item.payment_type === 'CAD') {
            const temp = item.payment_method
            this.cad.push(...temp)
          } else if (item.payment_type === 'EWALLET') {
            const temp = item.payment_method
            this.ewallet.push(...temp)
          }
          const children = item.payment_method.map((value) => {
            return {
              value: value.id,
              label: value.bank_name || '-',
            }
          })

          return {
            value: item.payment_term_code,
            label: item.payment_term_title,
            children,
          }
        } else {
          return {
            value: item.payment_term_code,
            label: item.payment_term_title,
          }
        }
      })
    },
    totalPrice() {
      if (!this.carts.length) {
        return 0
      }

      const warehouse_id = this.carts[0].id

      const { cart_list } = this.carts.find((item) => item.id === warehouse_id)

      const price = cart_list.reduce((acc, current) => {
        return acc + current.quantity * current.price.selling_price
      }, 0)

      return price || 0
    },
    getCreditTermLimit() {
      return `${this.data.credit_limit.term_value ?? ''} ${this.data.credit_limit.term_unit ?? '-'}`
    },
    getCreditBonds() {
      this.validationCreditLimit()
      return this.data.credit_limit.bond_type ?? '-'
    },
    getCreditBalance() {
      return `Rp. ${Intl.NumberFormat('en-US').format(this.data.credit_limit.balance || 0)}`
    },
    getMultipleBondAllowed() {
      return this.data.credit_limit.multiple_bond_allowed ?? 0
    },
    getCreditUsage() {
      return this.data.credit_limit.credit_limit_usage ?? 0
    },
  },
  mounted() {
    this.$store
      .dispatch('loyalty/GETLOYALTY', {})
      .then(({ data }) => {
        this.availablePoint = data.available_point
        // this.availablePoint = 9999999
        data.available_point = this.sums
      })
      .catch((err) => console.error(err))
      .finally(() => {
        this.loading = false
      })
    this.getPaymentMethod()
    this.getMaximumVAAmount()
    this.$store.state.meta.data.forEach((data) => {
      if (data?.meta_name === 'coin_term') {
        this.contentCoinTerm = data?.meta_value
      }
      if (data?.meta_name === 'loyalty_config') {
        const loyaltyConfig = JSON.parse(data?.meta_value || '{}')
        if ([true, false].includes(loyaltyConfig?.use_coins_for_payment)) {
          this.useCoinsForPayment = loyaltyConfig?.use_coins_for_payment
        }
      }
    })
  },
  methods: {
    onCloseAndCancelPayment() {
      this.$emit('handleCheckoutPage', false)
    },
    onPayNow() {
      this.$emit('handlePayNow')
    },
    onChangePaymentMethod(id, payment_type, method) {
      if ((payment_type.toUpperCase() === 'CAD' && this.invalidStatusCredit === true) || (payment_type.toUpperCase() === 'VA' && this.isMaxVAAmount(method))) {
        return
      }
      this.$emit('emitSelectedMethod', id)
    },
    onChangMixPaymentMethod(id, payment_type, method) {
      if ((payment_type.toUpperCase() === 'CAD' && this.invalidStatusCredit === true) || (payment_type.toUpperCase() === 'VA' && this.isMaxVAAmount(method))) {
        return
      }
      this.$emit('emitSelectedMixMethod', id)
    },
    changePhoneOVO(e) {
      this.phoneOVO = e.target.value
      this.$emit('emitPhoneOVO', e.target.value)
    },
    onChangeInsurace() {
      if (this.selectedShipping.compulsory_insurance === 0) {
        this.$emit('emitIsInsurance', !this.isInsurance)
        if (!this.isInsurance === false) {
          this.$emit('emitInsuranceCost', 0)
        } else {
          this.$emit('emitInsuranceCost', this.selectedShipping.insurance_price)
        }
      }
    },
    handleSelectShippingMethod(key) {
      this.modalShippingVisible = false
      this.selectedShipping = this.shippingMethods[key]
      this.$emit('emitSelectedShippingMethod', this.shippingMethods[key])
      if (this.selectedShipping.compulsory_insurance > 0) {
        this.$emit('emitIsInsurance', true)
        this.$emit('emitInsuranceCost', this.selectedShipping.insurance_price)
      } else {
        this.$emit('emitIsInsurance', false)
      }
    },
    handleCancelShippingMethod() {
      this.modalShippingVisible = false
    },
    handleShowShippingMethod() {
      this.getShippingMethod(true)
    },
    handleShowShippingMethodGuest() {
      if (this.selectedShippingAddress) {
        this.modalShippingVisible = true
        this.getShippingMethod(true)
      } else {
        this.$notification.error({
          message: 'Isi alamat pengiriman terlebih dahulu',
        })
      }
    },
    isMaxVAAmount(method) {
      const total = this.totalPrice ?? 0
      const findValue = this.maximumVAAmount.find((obj) => obj.va_name.toUpperCase() === method.toUpperCase())
      return findValue ? Boolean(total >= findValue.va_max_amount) : false
    },
    isMaxVAAmountMixPayment(method) {
      const total = this.remainingPrice ?? 0
      const findValue = this.maximumVAAmount.find((obj) => obj.va_name.toUpperCase() === method.toUpperCase())
      return findValue ? Boolean(total >= findValue.va_max_amount) : false
    },
    valueMaxVAAmount(method) {
      const findValue = this.maximumVAAmount.find((obj) => obj.va_name.toUpperCase() === method.toUpperCase())
      return findValue ? this.toCurrency(findValue.va_max_amount) : 0
    },
    getMaximumVAAmount() {
      this.$store.dispatch('meta/MAXIMUM_VA_AMOUNT').then(res => {
        const tempArrMaxVA = []
        Object.entries(res).forEach(([key, value]) => {
          tempArrMaxVA.push({
            va_name: key,
            va_max_amount: value,
          })
        })
        this.maximumVAAmount = tempArrMaxVA
      }).catch(err => {
        console.error(err)
      })
    },
    handleChangeLoyalty(e) {
      const sumLoyalty = e
      // alert(sumLoyalty)
      this.$store.commit('loyalty/SET_LOYALTY_STORE', {
        usedPoints: Number(sumLoyalty),
      })
    },
    handleCancel() {
      this.modalVisible = false
      this.data_method = ''
      this.$emit('emitSelectedMethod', null)
    },
    handleShippingCancel() {
      this.modalShippingVisible = false
    },
    handleCancelMixPayment() {
      this.modalVisibleMixPayment = false
      this.$emit('emitSelectedMixMethod', null)
    },
    getPaymentMethod() {
      const channel_id = this.$store.state.app.channel_id
      const seller_id = this.sellerId
      this.$store
        .dispatch('purchase/GETPAYMENTMETHOD', {
          seller_id,
          channel_id,
        })
        .then(({ data }) => {
          let parsePaymentTermConfig = null
          this.$store.state.meta.data.forEach((data) => {
            if (data?.meta_name === 'payment_term_config') {
              try {
                parsePaymentTermConfig = JSON.parse(data?.meta_value || '[]')
              } catch (error) {
                parsePaymentTermConfig = null
              }
            }
          })
          if (parsePaymentTermConfig?.length > 0) {
            data.payment_method = data.payment_method.filter(item => {
              return parsePaymentTermConfig.includes(item.payment_type)
            })
          }
          this.data = data
        })
        .catch((err) => {
          console.error(err)
        })
    },
    getShippingMethod() {
      const warehouse_id = this.carts[0].id || 0
      const channel_id = this.$store.state.app.channel_id
      if (this.distination_id) {
        this.modalShippingVisible = true
        this.isLoadingShippingMethod = true
        this.$store
          .dispatch('purchase/GETSHIPPINGMETHOD', {
            channel_id,
            warehouse_id,
            params: {
              weight: this.totalWeight,
              value: this.totalPrice,
              destination_id: this.distination_id,
            },
          })
          .then(({ data }) => {
            this.shippingMethods = data.filter((obj) => !IGNORE_SHIPPING_CODE.includes(obj?.service?.code))
            if (this.selectedShippingType === 'pickup') {
              this.selectedShipping = this.shippingMethods[0]
              this.$emit('emitSelectedShippingMethod', this.shippingMethods[0])
            }
            this.isLoadingShippingMethod = false
          })
          .catch((err) => {
            this.isLoadingShippingMethod = false
            this.shippingMethods = []
            console.error(err)
            this.$notification.error({
              message: 'Error',
              description: 'Terjadi kesalahan, coba beberapa saat lagi.',
            })
          })
      } else {
        this.showModalMandatoryShippingAddress = true
      }
    },
    setSum() {
      return (this.sum = parseFloat(
        this.rewardAmountsApplied.reduce((a, b) => a + b),
      ).toFixed(0))
    },
    applyDiscount() {
      var amount = this.loyaltyPoints
      setTimeout(() => {
        if (Number(amount) > Number(this.availablePoint)) {
          this.seen_balance = true
        } else {
          // push in the amount as an int
          this.rewardAmountsApplied.push(+amount)

          // get the last discount in the array
          this.availablePoint = Number(this.availablePoint) - Number(amount)
          this.availablePoint = parseFloat(this.availablePoint).toFixed(0)
          this.seen_balance = false
          this.loyaltyPoints = 0
          this.setSum()
        }
        this.$store.commit('loyalty/SET_LOYALTY_STORE', {
          usedPoints: Number(this.sum),
        })
      }, 1000)
    },
    removeDiscount() {
      // reset the balance
      this.availablePoint = Number(this.availablePoint) + Number(this.sum)
      // empty the total rewards array
      this.rewardAmountsApplied = [0]
      this.seen_balance = false
      this.setSum()
    },
    handleSelectPayment(value) {
      this.modalVisible = !this.modalVisible
      let selectedPayment
      let selectedPaymentImage
      ;(this.paymentList.payment_method || []).forEach((list) => {
        list.payment_method.forEach((item) => {
          if (item.id === value) {
            selectedPayment = {
              term: list.payment_term,
              method_id: item.id,
              method: item.method,
              bank: item.bank_name,
              number: item.account_number,
              payment_name: item.payment_name,
              payment_type: list.payment_type,
              pg_channel_id: item.pg_channels_id,
            }
            selectedPaymentImage = {
              term: list.payment_term,
              method_id: item.id,
              method: item.method,
              bank: item.bank_name,
              number: item.account_number,
              image: item.image,
              type: list.payment_type,
              payment_name: item.payment_name,
              payment_type: list.payment_type,
              pg_channel_id: item.pg_channels_id,
            }
          }
        })
      })
      if (selectedPayment !== undefined) {
        this.data_method = selectedPaymentImage
        if (selectedPaymentImage?.term === 'CAD') {
          this.remainingPrice = this.grandTotal
          const creditUsed = this.data.credit_limit.balance < (this.grandTotalBeforeCreditLimit - this.tempUsedPoints) ? this.data.credit_limit.balance : (this.grandTotalBeforeCreditLimit - this.tempUsedPoints)
          this.creditLimitUsage = creditUsed
          this.$emit('creditUsed', creditUsed)
          this.$emit('handleCurrentTotalCreditLimit', this.data.credit_limit.balance)
        } else {
          this.data_mix_method = ''
          this.creditLimitUsage = 0
          this.$emit('creditUsed', 0)
          this.$emit('handleCurrentTotalCreditLimit', 0)
          this.remainingPrice = 0
        }
        this.$emit('setSelectedPayment', selectedPayment)
        this.onFilterMixPayment(selectedPayment.term)
      }
    },
    onFilterMixPayment(value) {
      this.mixPaymentMethod = this.data.payment_method.filter((obj) => {
        return obj.payment_type !== value
      })
    },
    handleSelectMixPayment(value) {
      this.modalVisibleMixPayment = !this.modalVisibleMixPayment
      let selectedPayment
      let selectedPaymentImage
      ;(this.paymentList.payment_method || []).forEach((list) => {
        list.payment_method.forEach((item) => {
          if (item.id === value) {
            selectedPayment = {
              term: list.payment_term,
              method_id: item.id,
              method: item.method,
              bank: item.bank_name,
              number: item.account_number,
              payment_name: item.payment_name,
              payment_type: list.payment_type,
              pg_channel_id: item.pg_channels_id,
            }
            selectedPaymentImage = {
              term: list.payment_term,
              method_id: item.id,
              method: item.method,
              bank: item.bank_name,
              number: item.account_number,
              image: item.image,
              type: list.payment_type,
              payment_name: item.payment_name,
              payment_type: list.payment_type,
              pg_channel_id: item.pg_channels_id,
            }
          }
        })
      })
      if (selectedPayment !== undefined) {
        this.data_mix_method = selectedPaymentImage
        this.$emit('setSelectedMixPayment', selectedPayment)
      }
    },
    onChangeUsedCoin() {
      this.seen = !this.seen
      if (this.seen) {
        this.$store.commit('loyalty/SET_LOYALTY_STORE', {
          usedPoints: Number(this.availablePoint),
        })
      } else {
        this.$store.commit('loyalty/SET_LOYALTY_STORE', {
          usedPoints: null,
        })
      }
    },
    onChangeSelectPoint() {
      this.seen_points = !this.seen_points
    },
    validationCreditLimit() {
      const creditLimit = this.data.credit_limit
      if (creditLimit.is_valid === false) {
        this.invalidStatusCredit = true
        // single bond
        if (creditLimit.multiple_bond_allowed === 1) {
          if (creditLimit.balance === 0) {
            this.selectedStatusCredit = 1
          } else {
            if (creditLimit.multiple_bond_allowed === creditLimit.credit_limit_usage) {
              this.selectedStatusCredit = 2
            } else {
              this.selectedStatusCredit = 1
            }
          }
        // double bond
        } else {
          if (creditLimit.balance === 0) {
            this.selectedStatusCredit = 1
          } else {
            if (creditLimit.multiple_bond_allowed === creditLimit.credit_limit_usage) {
              this.selectedStatusCredit = 3
            } else {
              this.selectedStatusCredit = 2
            }
          }
        }
      } else {
        this.invalidStatusCredit = false
        if ((this.grandTotalBeforeCreditLimit - creditLimit.balance - this.depositReturnUsed - this.usedPoints) > 0) {
          this.selectedStatusCredit = 0
        } else {
          this.selectedStatusCredit = null
        }
      }
    },
    toCurrency(value) {
      return `${Intl.NumberFormat('en-US').format(value || 0)}`
    },
    emitShowModalVoucher(val) {
      this.showModalVoucher = val
    },
    emitSubmitModalVoucher(val) {
      this.$emit('emitSelectedVoucher', val)
      this.voucherUsed = val.filter((obj) => obj.checked === true)

      this.$emit('emitSelectedMethod', '')
      this.$emit('emitSelectedMixMethod', '')
      this.showModalVoucher = false

      this.seen = false
      this.$store.commit('loyalty/SET_LOYALTY_STORE', {
        usedPoints: null,
      })
    },
    getContainer(id) {
      return () => {
        if (!id || typeof document === 'undefined') return null
        return document.getElementById(id)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.form-select-coin {
  margin-top: 20px;
  height: 35px;
  width: 275px;
  font-size: 20px;
}
.checkout-cart {
  margin-bottom: 1rem;
  border: 0.716px solid var(--biz-base-20);
  border-radius: 10px;

  &__poin {
    background: var(--biz-brand-base);
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;

    .title {
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
      color: var(--biz-base-100);
    }
  }

  &__poin2 {
    background: var(--biz-brand-base);
    box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.15);
    border-radius: 10px;

    .title {
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
      color: var(--biz-base-100);
    }

    .content {
      font-weight: bold;
      font-size: 16px;
      line-height: 22px;
      color: var(--biz-accent-status-1);
      margin-left: 10px;
      vertical-align: top;
    }
  }

  &__calculation {
    background: var(--biz-brand-base);
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: var(--biz-base-100);
    font-style: normal;

    .title {
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
    }

    .content {
      font-weight: bold;
      font-size: 16px;
      line-height: 22px;
      color: var(--biz-accent-status-1);
    }
  }

  &__pay-method {
    background: var(--biz-brand-base);
    align-items: center;
    color: var(--biz-base-100);
    font-style: normal;

    .span.ant-radio {
      float: right;
    }

    .title {
      font-weight: bold;
      font-size: 16px;
      line-height: 22px;
      font-family: 'Open Sans';
    }

    .subtitle {
      font-weight: 500;
      font-size: 14px;
      line-height: 22px;
      font-family: 'Open Sans';
    }

    .title2 {
      font-weight: bold;
      font-size: 16px;
      line-height: 22px;
      font-family: 'Open Sans';
    }

    .list-card {
      background: var(--biz-brand-base);
      padding: 10px;
      border-radius: 10px;
      margin-bottom: 10px;
    }

    .confirm-payment {
      background: var(--biz-base-100);
      border: 1px solid var(--biz-base-100);
      border-radius: 5px;
      color: var(--biz-brand-base);
      cursor: pointer;
      padding: 10px;
      font-size: 16px;
      font-weight: 600;
    }
    .confirm-payment:disabled {
      background-color: #5d5d5d;
      opacity: 0.5;
      cursor: not-allowed;
    }
    .cancel-payment {
      background: var(--biz-brand-base);
      border: 1px solid var(--biz-base-100);
      border-radius: 5px;
      color: var(--biz-base-100);
      cursor: pointer;
      padding: 10px;
      font-size: 16px;
      font-weight: 600;
    }
  }

  &__content {
    background: var(--biz-brand-base);
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;

    .warehouse-name {
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      line-height: 19px;
      letter-spacing: 0.05em;
      color: var(--biz-base-100);

      @media (max-width: 600px) {
        font-size: 14px;
      }
    }

    .warehouse-address {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 22px;
      color: var(--biz-primary-60);

      @media (max-width: 600px) {
        font-size: 12px;
      }
    }

    .product-title {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: var(--biz-base-100);

      @media (max-width: 600px) {
        font-size: 12px;
      }
    }

    .product-total {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 20px;
      margin-right: 10px;

      @media (max-width: 600px) {
        font-size: 14px;
      }
    }

    .product-align {
      text-align: right;
    }

    .product-size {
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      color: var(--biz-base-20);

      @media (max-width: 600px) {
        font-size: 12px;
      }
    }

    .product-price {
      &__discount {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 18px;
        text-decoration-line: line-through;
        color: var(--biz-primary-40);
      }

      &__selling {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: var(--biz-base-100);
      }
    }

    .payment-title {
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      color: var(--biz-base-100);
    }

    .payment-list {
      height: 35px;
      background: var(--biz-accent-2);
      border-radius: 8px;
      color: var(--biz-brand-base);
      padding: 0.5rem;
      cursor: pointer;
    }
  }

  .ant-cascader-picker {
    background: var(--biz-brand-base);
    border: 1px solid var(--biz-accent-2);
    box-sizing: border-box;
    border-radius: 5px;
    color: var(--biz-accent-2);

    ::placeholder {
      color: var(--biz-accent-2) !important;
    }
  }

  .payment-method {
    background: var(--biz-brand-base);
    box-sizing: border-box;
    border-radius: 10px;
    color: var(--biz-primary-40);
    height: 40px;
    background: rgba(237, 28, 36, 0.06);
    border-radius: 10px;

    &__calculation {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: var(--biz-primary-40);
      font-style: normal;

      .title {
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
      }

      .content {
        font-weight: bold;
        font-size: 16px;
        line-height: 22px;
        color: var(--biz-accent-status-1);
      }
    }
  }

  .mix-payment-method {
    background: var(--biz-brand-base);
    border: 1px solid var(--biz-primary-20);
    box-sizing: border-box;
    border-radius: 10px;
    color: var(--biz-base-100);
    height: 40px;
    box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.15);
    border-radius: 10px;

    &__calculation {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-style: normal;

      .title {
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
      }

      .content {
        font-weight: bold;
        font-size: 16px;
        line-height: 22px;
        color: var(--biz-accent-status-1);
      }
    }
  }

  .voucher {
    background: var(--biz-brand-base);
    border: 1px solid var(--biz-brand-base);
    box-sizing: border-box;
    border-radius: 10px;
    color: var(--biz-base-100);
    height: 40px;
    box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.15);
    border-radius: 10px;

    &__calculation {
      background: var(--biz-brand-base);
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: var(--biz-primary-40);
      font-style: normal;

      .title {
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
      }

      .content {
        font-weight: bold;
        font-size: 16px;
        line-height: 22px;
        color: var(--biz-base-100);
      }
    }
  }
}
.list-card {
  background: var(--biz-brand-base);
  padding: 15px;
  border-radius: 10px;
  margin-bottom: 10px;
}
.list-card2 {
  background: var(--biz-brand-base);
  padding: 10px;
  border-radius: 10px;
}
select {
  padding: 10px;
  padding-right: 30px;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
  background-image: url('data:image/svg+xml;charset=US-ASCII,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --><path d="M224 416c-8.188 0-16.38-3.125-22.62-9.375l-192-192c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L224 338.8l169.4-169.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-192 192C240.4 412.9 232.2 416 224 416z"/></svg>');
  background-repeat: no-repeat, repeat;
  background-position: right 0.7em top 50%, 0 0;
  background-size: 0.65em auto, 100%;
}

/* For IE (thanks to @SaiManoj) */
select::-ms-expand {
  display: none;
}
// Force to style CSS (Not recommended) For Select Koin Box
select#list-coin {
  background-color: var(--biz-accent-2) !important;
  color: var(--biz-brand-base);
  border-radius: 5px !important;
  height: 40px;
  width: 275px;
  line-height: 20px;
  outline: none; /*Add this*/
}
.pointer {
  cursor: pointer;
}
.radio-bank-background {
  background-color: var(--biz-accent-2);
  width: 200px;
}
.tag-status {
  background-color: var(--biz-brand-base);
  padding: 1px 15px;
  border: 1px solid;
  border-radius: 100px;
}
.tag-credit-usage {
  background-color: var(--biz-accent-2);
  padding: 2px 15px;
  border-radius: 100px;
  color: var(--biz-brand-base);
  font-family: Open Sans;
  font-size: 12px;
  font-weight: 700;
}
.text-credit-balance {
  color: var(--biz-accent-status-1);
  font-size: 18px;
  font-weight: 700;
  line-height: 25px;
}
.info-container {
  border-radius: 12px;
  gap: 0px 10px;
  .info-text {
    font-family: Open Sans;
    font-size: 14px;
    font-weight: 400;
    line-height: 19px;
    letter-spacing: 0em;
    text-align: left;
  }
}
.selected-payment {
  border: 1px solid var(--biz-accent-2);
  border-radius: 12px;
  padding: 12px;
  &-container {
    background: var(--biz-brand-base);
    border-radius: 12px;
    padding-left: 10px;
  }
}
.text-remaining-price {
  font-family: Open Sans;
  font-size: 16px;
  font-weight: 700;
  line-height: 25px;
  letter-spacing: 0em;
  color: var(--biz-secondary-100);
}
.disclaimer-max-payment {
  b {
    font-family: Open Sans;
    font-size: 14px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0em;
    text-align: left;
  }
  font-family: Open Sans;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: 0em;
  text-align: left;

}
.item-product {
  align-items: center!important;
  display: flex;
  justify-content: space-between;
  padding-bottom: 15px;
}
.item-product-container {
  border-bottom: 1px solid var(--biz-primary-20);
}
.section-title {
  font-size: 18px;
  font-weight: 600;
  margin: 20px 0 10px 0;
}
.title-payment-method {
  display: flex;
  align-items: center;
  gap: 15px;
}
.subtotal {
  display: flex;
  justify-content: space-between;
  margin: 20px 35px;
  .title {
    font-weight: 700;
    font-size: 16px;
  }
  .value {
    color: var(--biz-secondary-100);
  }
}
.btn-method-submit {
  background-color: var(--biz-base-100);
  border: 1px solid var(--biz-base-100);
  color: var(--biz-brand-base);
  padding: 8px;
  border-radius: 8px;
  font-size: 16px;
}
.btn-method-cancel {
  background-color: var(--biz-brand-base);
  border: 1px solid var(--biz-base-100);
  color: var(--biz-base-100);
  padding: 8px;
  border-radius: 8px;
  font-size: 16px;
}
.btn-disabled-save {
  background-color: grey!important;
  cursor: not-allowed;
}
.button-close-modal-mandatory {
  height: 40px;
  font-style: normal;
  font-weight: 500;
  color: #FFFFFF;
  background: var(--biz-brand-button);
  display: flex;
  justify-content: center;
  align-items: center;
  border: 0;

  &[disabled] {
    opacity: .5;
  }
}
.btn-voucher {
  background: var(--biz-brand-base);
  border: 0.716px solid var(--biz-primary-20);
  border-radius: 10px;
  cursor: pointer;
}
.voucher-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .voucher-title-icon {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
    font-weight: 600;
    font-size: 16px;
  }
}
.discount-tag {
  color: var(--biz-brand-base);
  background: var(--biz-brand-legacy);
  padding: 2px 8px;
  border-radius: .15rem;
  margin-left: 10px;
  font-size: 10px;
  vertical-align: top;
}
.final-price {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: var(--biz-brand-legacy);
}
</style>
<style lang="scss">
.ant-drawer > * {
  transition: unset !important;
}
</style>
